<template>
  <v-dialog v-model="showModal" max-width="400px"  persistent>
    <v-card>
      <v-card-title>{{ node.name }}</v-card-title>
      <v-card-text>
        <p><strong>Encargado:</strong> {{ node.encargado }}</p>
        <p><strong>Clasificación:</strong> {{ node.clasificacion }}</p>
        <!-- Mostrar la imagen del nodo si está disponible -->
        <img v-if="imageUrl" :src="imageUrl" alt="Imagen del Nodo" style="max-width: 30%;" />
      </v-card-text>
      <v-card-actions>
        <v-btn color="blue" @click="editNode">Editar</v-btn>
        <v-btn color="black" text @click="closeModal">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    node: Object
  },
  data () {
    return {
      showModal: true, // Controla la visualización del modal
      imageUrl: null // Almacena la URL de la imagen para mostrarla
    }
  },
  mounted () {
    // Asignar la URL de la imagen si está disponible
    if (this.node.image) {
      // Si node.image es un archivo, usar FileReader para convertirlo en una URL
      if (this.node.image instanceof File) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.imageUrl = e.target.result // Asignar la Data URL de la imagen
        }
        reader.readAsDataURL(this.node.image) // Convertir el archivo a una URL temporal
      } else if (typeof this.node.image === 'string') {
        // Si ya es una URL (string), asignarla directamente
        this.imageUrl = this.node.image
      }
    }
  },
  methods: {
    closeModal () {
      this.showModal = false
      this.$emit('close') // Emitir evento para cerrar el modal
    },
    editNode () {
      this.$emit('edit', this.node) // Emitir evento para editar el nodo
    }
  }
}
</script>

<style scoped>
/* Estilos del modal */
</style>
